



















































import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { OptionDropDownSelector, ComboBoxSelector } from "../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../base/components/system/selectors/mixins";
import { TextAreaStyle, Color, TextAlignKinds } from "../../../../../base/domain/drawing";
import { ColorPicker } from "../../../../../base/components/drawing";
import { CommonComponentsContainer } from "../../../../../formatEditor/components/format/editors/contents";

@Component({
  components: {
    OptionDropDownSelector,
    ComboBoxSelector,
    ColorPicker,
  }
})
export default class TextStyleEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (writer: (source: TextAreaStyle) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: TextAreaStyle) => T, defaultValue: T) => T;

  @Prop()
  commonComponents: CommonComponentsContainer;

  @Prop()
  pallet: Color[];

  @Prop()
  alignmentOptions: StandardOption<TextAlignKinds>[];

  @Prop({ default: true })
  isFontColorSelectable: boolean;

  @Prop({ default: true })
  isPaintColorSelectable: boolean;

  @Prop({default: () => ({
    backgroundColor: {
      isEnable: true,
    },
    fontName: {
      isEnable: true,
    },
    fontSize: {
      isEnable: true,
    },
    fontColor: {
      isEnable: true,
    },
    alignment: {
      isEnable: true,
    },
  })})
  option: {
    backgroundColor: {
      isEnable: boolean;
    },
    fontName: {
      isEnable: boolean;
    },
    fontSize: {
      isEnable: boolean;
    },
    fontColor: {
      isEnable: boolean;
    },
    alignment: {
      isEnable: boolean;
    },
  };

  data(): any {
    return {
      fontSizeOptions: [
        8,
        9,
        10,
        11,
        12,
        14,
        16,
        18,
        20,
        22,
        24,
        26,
        28,
        36,
        48,
        72,
        108,
        156,
        216,
      ],
    };
  }
  fontSizeOptions: number[];

  get fontColor(): Color {
    return this.readPropertyOrDefault(s => s.fontStyle.color, this.defaultColor);
  }

  set fontColor(value: Color) {
    this.writePropertyWhenValid(s => s.fontStyle.color = value);
  }

  get fontSize(): number {
    return this.readPropertyOrDefault(s => s.fontStyle.font.size, 9);
  }

  set fontSize(value: number) {
    this.writePropertyWhenValid(s => s.fontStyle.font.size = value);
  }

  get fontName(): string {
    return this.readPropertyOrDefault(s => s.fontStyle.font.family, "ＭＳ ゴシック");
  }

  set fontName(value: string) {
    this.writePropertyWhenValid(s => s.fontStyle.font.family = value);
  }

  get fontOptions(): StandardOption<string>[] {
    return Enumerable.from(this.fontSpecification).select(s => new StandardOption(s, s)).toArray();
  }

  get fontSpecification(): string[] {
    return this.commonComponents.readPropertyOrDefault(s => s.getSpecification().fontFamilyNames, []);
  }

  get defaultColor(): Color {
    return new Color("#000000");
  }

  get isBackgroundColorEnable(): boolean {
    return this.readPropertyOrDefault(s => s.paintStyle.isEnable, false);
  }

  set isBackgroundColorEnable(value: boolean) {
    this.writePropertyWhenValid(s => s.paintStyle.isEnable = value);
  }

  get disabledBackgroundColorPicker(): boolean {
    return this.isBackgroundColorEnable === false;  // 複数選択された場合nullになるため厳密にfalseのみ使用不可にする
  }

  get backgroundColor(): Color {
    return this.readPropertyOrDefault(s => s.paintStyle.color, this.defaultColor);
  }

  set backgroundColor(value: Color) {
    this.writePropertyWhenValid(s => s.paintStyle.color = value);
  }

  get alignment(): TextAlignKinds {
    return this.readPropertyOrDefault(s => s.alignment, TextAlignKinds.Left);
  }

  set alignment(value: TextAlignKinds) {
    this.writePropertyWhenValid(s => s.alignment = value);
  }

  equivalentValidator(source: string, destination: string): boolean {
    return !!source === !!destination && source === destination;
  }
}
